import headboardSimpleAdapter, {
  headboardSimpleHomeAdapter,
} from "./headboardSimple.adapter";

import HeadboardSimple from "./headboardSimple";

export default HeadboardSimple;
export { headboardSimpleAdapter, headboardSimpleHomeAdapter };
